/**
 * Maps Firebase Authentication error codes to user-friendly Spanish messages.
 *
 * @param {Error} error - Firebase auth error object
 * @returns {string} User-friendly error message in Spanish
 */
export function getFirebaseAuthErrorMessage(error) {
  // Firebase auth errors have a 'code' property
  const errorCode = error?.code || '';

  const errorMessages = {
    // Email/Password errors
    'auth/invalid-email': 'El correo electrónico no es válido. Verifica el formato.',
    'auth/user-disabled': 'Esta cuenta ha sido desactivada. Contacta al administrador.',
    'auth/user-not-found': 'Correo o contraseña incorrectos. Intenta de nuevo.',
    'auth/wrong-password': 'Correo o contraseña incorrectos. Intenta de nuevo.',
    'auth/invalid-credential': 'Correo o contraseña incorrectos. Intenta de nuevo.',

    // Password errors
    'auth/weak-password': 'La contraseña es muy débil. Usa al menos 6 caracteres.',

    // Rate limiting
    'auth/too-many-requests': 'Demasiados intentos fallidos. Espera unos minutos antes de intentar de nuevo.',

    // Network errors
    'auth/network-request-failed': 'Error de conexión. Verifica tu internet e intenta de nuevo.',

    // Google sign-in errors
    'auth/popup-closed-by-user': 'Se cerró la ventana de inicio de sesión. Intenta de nuevo.',
    'auth/popup-blocked': 'La ventana emergente fue bloqueada. Permite ventanas emergentes e intenta de nuevo.',
    'auth/cancelled-popup-request': 'Se canceló el inicio de sesión. Intenta de nuevo.',
    'auth/account-exists-with-different-credential': 'Ya existe una cuenta con este correo. Usa otro método de inicio de sesión.',

    // General errors
    'auth/operation-not-allowed': 'Este método de inicio de sesión no está habilitado.',
    'auth/requires-recent-login': 'Por seguridad, inicia sesión de nuevo.',
    'auth/internal-error': 'Ocurrió un error interno. Intenta de nuevo más tarde.',
  };

  return errorMessages[errorCode] ||
    'Ocurrió un error al iniciar sesión. Intenta de nuevo.';
}
